module.exports = __webpack_public_path__ + "fonts/fa-regular-400.1a3b38d.woff2";